var map = {
	"./Access Denied.svg": "a42b",
	"./Arrow.svg": "af5f",
	"./Blank.svg": "5502",
	"./Change Document.svg": "90d5",
	"./Company Users.svg": "bca02",
	"./Company_users_active.svg": "668d",
	"./Detach.svg": "15fe",
	"./Document Initiate.svg": "ce3e",
	"./Documents.svg": "8973e",
	"./File-uploaded.svg": "2b05",
	"./Filter.svg": "b510",
	"./Hand.svg": "067a",
	"./Icon_File_2px.svg": "169c",
	"./Invisibility.svg": "7e21",
	"./JPG.svg": "ca37",
	"./Locked.svg": "df9d",
	"./Logout.svg": "9941",
	"./PNG.jpg": "2ed56",
	"./PNG.svg": "2aac",
	"./Sent.svg": "5297",
	"./T3J00K0HJ-U3HT5L18A-8f34e2cbbce3-48.jpg": "8f460",
	"./TXT.svg": "c71e",
	"./Upload-file-2.svg": "2087",
	"./Upload-file-3.svg": "cb4f",
	"./Viewed.svg": "6b5c",
	"./Workflow.svg": "3278",
	"./add-benefits.svg": "00e0",
	"./add-btn.svg": "a693",
	"./add-entity-icon.svg": "a1fd",
	"./add-field.svg": "4c65",
	"./add-template.svg": "9fa0",
	"./add_col_after.svg": "245f",
	"./add_col_before.svg": "2ebf",
	"./add_row_after.svg": "605d6",
	"./add_row_before.svg": "d2e5",
	"./alert.svg": "8546",
	"./all-templates.svg": "2306",
	"./all-workflow-2.svg": "cd99",
	"./all-workflows.svg": "8f46",
	"./bold.svg": "54be",
	"./calendar.svg": "557c",
	"./card-type/Aadhar Card.svg": "2581",
	"./card-type/I-94.svg": "78c0",
	"./card-type/Passport.svg": "7555",
	"./card-type/Void Cheque.svg": "fc61",
	"./card-type/card.svg": "843a",
	"./categories-documents.svg": "bc34",
	"./check-circle-fill.svg": "86fc",
	"./checklist.svg": "5510",
	"./close-icon.svg": "1785",
	"./close.svg": "6282",
	"./code.svg": "3983",
	"./combine_cells.svg": "b4c9",
	"./company-templates.svg": "b256",
	"./company_name.svg": "eb66",
	"./complete.svg": "a347",
	"./create.svg": "eaae",
	"./custom-documents.svg": "4683",
	"./custom.svg": "1659",
	"./dashboardActiveIcons/all_documents.svg": "d41b",
	"./dashboardActiveIcons/approved.svg": "67b9",
	"./dashboardActiveIcons/company-documents.svg": "bb79",
	"./dashboardActiveIcons/completed.svg": "7892",
	"./dashboardActiveIcons/declined.svg": "0086",
	"./dashboardActiveIcons/deleted.svg": "b59b",
	"./dashboardActiveIcons/draft_docs.svg": "614b",
	"./dashboardActiveIcons/expired.svg": "6696",
	"./dashboardActiveIcons/expiring_soon.svg": "9174",
	"./dashboardActiveIcons/sent_docs.svg": "aec1",
	"./dashboardActiveIcons/voided.svg": "0797",
	"./dashboardActiveIcons/waiting_for_me.svg": "c4d9",
	"./dashboardActiveIcons/waiting_for_others.svg": "6ba5",
	"./dashboardStatsIcons/all_documents.svg": "5f7f",
	"./dashboardStatsIcons/approved.svg": "8903",
	"./dashboardStatsIcons/company-documents.svg": "42ff",
	"./dashboardStatsIcons/completed.svg": "fdc8",
	"./dashboardStatsIcons/declined.svg": "14e4",
	"./dashboardStatsIcons/deleted.svg": "338d",
	"./dashboardStatsIcons/draft_docs.svg": "bc84",
	"./dashboardStatsIcons/expired.svg": "3a66",
	"./dashboardStatsIcons/expiring_soon.svg": "7b75",
	"./dashboardStatsIcons/sent_docs.svg": "585c",
	"./dashboardStatsIcons/voided.svg": "cdf1",
	"./dashboardStatsIcons/waiting_for_me.svg": "69f3a",
	"./dashboardStatsIcons/waiting_for_others.svg": "2bd3",
	"./date-signed.svg": "07ed",
	"./delete.png": "e1ed",
	"./delete.svg": "28e1",
	"./delete_col.svg": "3f58",
	"./delete_row.svg": "cf1e1",
	"./delete_table.svg": "5870",
	"./doc-file.svg": "0114",
	"./docs-file.svg": "aed5",
	"./docs.png": "b991",
	"./document_corrected.svg": "8481",
	"./download-docuement.svg": "fa75",
	"./download.svg": "24a4",
	"./edit-document.svg": "9a48",
	"./edit.svg": "8399",
	"./education-White/Academics.svg": "67ee",
	"./education-White/Arrow.svg": "7833",
	"./education-White/Attendance.svg": "76e25",
	"./education-White/Download Center.svg": "4883",
	"./education-White/Examination.svg": "f83f",
	"./education-White/Fee Collection.svg": "938a",
	"./education-White/Human Resource.svg": "02ffd",
	"./education-White/Inventory.svg": "c1a7",
	"./education-White/Lead Management.svg": "b9b6",
	"./education-White/Student Information.svg": "2336",
	"./education-black/Academics.svg": "7ad0",
	"./education-black/Arrow.svg": "3f1a",
	"./education-black/Attendance.svg": "5b8a",
	"./education-black/Download Center.svg": "45c9",
	"./education-black/Examination.svg": "ec5e",
	"./education-black/Fee Collection.svg": "5590",
	"./education-black/Human Resource.svg": "0ce3",
	"./education-black/Inventory.svg": "baa3",
	"./education-black/Lead Management.svg": "5a0b",
	"./education-black/Student Information.svg": "ef36",
	"./entity-stat-icons/Data Workflows-Active.svg": "d07c",
	"./entity-stat-icons/DataWorkflowsInactive.svg": "1d91",
	"./entity-stat-icons/Document Data-Active.svg": "2ab9",
	"./entity-stat-icons/DocumentDataInactive.svg": "4ee9",
	"./entity-stat-icons/Documents-Active.svg": "dc84",
	"./entity-stat-icons/DocumentsInactive.svg": "aa6c",
	"./entity-stat-icons/Icon-Entities-Active.svg": "8018",
	"./entity-stat-icons/IconEntitiesInactive.svg": "b9b2",
	"./entity-stat-icons/avatar-person.svg": "eb9c",
	"./entityViews/BOARD.svg": "bc69",
	"./entityViews/CALENDAR.svg": "23cb0",
	"./entityViews/CARDS.svg": "4c40",
	"./entityViews/CHARTS.svg": "444b",
	"./entityViews/EYE.svg": "e778",
	"./entityViews/HIDE.svg": "e027",
	"./entityViews/HTML_CONTENT.svg": "45f0",
	"./entityViews/TABLE.svg": "8b34",
	"./entityViews/TIMELINE.svg": "48bb",
	"./entityViews/active/BOARD.svg": "ee5e",
	"./entityViews/active/CALENDAR.svg": "3e0c",
	"./entityViews/active/CARDS.svg": "ff66",
	"./entityViews/active/CHARTS.svg": "1581",
	"./entityViews/active/HTML_CONTENT.svg": "3457",
	"./entityViews/active/TABLE.svg": "4505",
	"./entityViews/active/TIMELINE.svg": "7cd0",
	"./entityViews/gallery.svg": "d273",
	"./entityViews/layoutselect.svg": "9770",
	"./eye-table.svg": "019b",
	"./feature-list.svg": "18c6",
	"./files-2.svg": "db92",
	"./files-categories.svg": "b892",
	"./files-menu.svg": "c843",
	"./files-white.svg": "0819",
	"./files.svg": "868b",
	"./first_name.svg": "6297",
	"./flow-close-icon.svg": "055c",
	"./folder-line.svg": "c9d2",
	"./folder-white.svg": "4a2d",
	"./folder.svg": "baec",
	"./formRules/CHANGE_COLOR.svg": "8f27",
	"./formRules/DECREMENT.svg": "b829",
	"./formRules/DISABLE.svg": "a7a3",
	"./formRules/ENABLE.svg": "3b53",
	"./formRules/HIDE.svg": "5576",
	"./formRules/HIDE_OPTIONS.svg": "ec86",
	"./formRules/INCREMENT.svg": "605b",
	"./formRules/MULTIPLY.svg": "03d7",
	"./formRules/Make_this_field_required.svg": "9fcb",
	"./formRules/Make_this_field_unrequired.svg": "4219",
	"./formRules/PULL.svg": "01bf",
	"./formRules/PUSH.svg": "6e5e",
	"./formRules/SHOW.svg": "a0ae",
	"./formRules/SHOW_IN_POPUP.svg": "5914",
	"./formRules/UPDATE.svg": "eadb",
	"./formRules/UPDATE_PROPERTY.svg": "9a03",
	"./formRules/changelabel.svg": "2936",
	"./formRules/empty_field.svg": "4920",
	"./formRules/future_dates.svg": "3b66",
	"./formRules/hide-form-rule.svg": "6691",
	"./formRules/if-form-rule.svg": "ebee",
	"./formRules/min_max.svg": "7ff8",
	"./formRules/past_dates.svg": "d56a",
	"./fortePayment.png": "1c55",
	"./gear.svg": "567a",
	"./github.svg": "4a1d",
	"./google.svg": "905a",
	"./group-files.png": "d337",
	"./guide-icon.svg": "60e9",
	"./hover-dots.svg": "55c8",
	"./hr.svg": "ee9b",
	"./icons8-search.svg": "0269",
	"./image-file.svg": "b2a7",
	"./image.svg": "95bd",
	"./information.svg": "2486",
	"./italic.svg": "0810",
	"./job-offer.svg": "eda8",
	"./jpeg-image.png": "be70",
	"./jpg.png": "a67d",
	"./left-arrow.svg": "e248",
	"./link.svg": "7c12",
	"./linkedin.svg": "11db",
	"./mail-alert.svg": "6298",
	"./mail.svg": "90e4",
	"./mention.svg": "2b36",
	"./menu/Achievement.svg": "9d82",
	"./menu/AddressInfo.svg": "494f",
	"./menu/ApprovalForms.svg": "3213",
	"./menu/Attendance.svg": "10de",
	"./menu/Badge.svg": "e247",
	"./menu/Bank&Finance/Accounting.svg": "c873",
	"./menu/Bank&Finance/Bank.svg": "2fb1",
	"./menu/Bank&Finance/Currency.svg": "88fa",
	"./menu/Bank&Finance/CustomerService.svg": "1013",
	"./menu/Bank&Finance/DealsMoney.svg": "da5a",
	"./menu/Bank&Finance/Deposit.svg": "828f",
	"./menu/Bank&Finance/DigitalCommerce.svg": "84dc",
	"./menu/Bank&Finance/Exchange.svg": "9a3f",
	"./menu/Bank&Finance/FundingPlatform.svg": "a1fb",
	"./menu/Bank&Finance/Growth.svg": "babd",
	"./menu/Bank&Finance/InterestRate.svg": "d8f4",
	"./menu/Bank&Finance/MarketingResearch.svg": "c768",
	"./menu/Bank&Finance/MobileMarketing.svg": "709c",
	"./menu/Bank&Finance/MoneyManagement.svg": "9cf5",
	"./menu/Bank&Finance/Savings.svg": "da11",
	"./menu/Bank&Finance/Statistics.svg": "3a12",
	"./menu/Bank&Finance/TimeManagement.svg": "77c6",
	"./menu/BestEmployee.svg": "117b",
	"./menu/Billing.svg": "ce1d",
	"./menu/Bug Tracker.svg": "f4a5",
	"./menu/Calendar.svg": "8c11",
	"./menu/Certificate.svg": "5d50",
	"./menu/Chart.svg": "816c",
	"./menu/Check.svg": "8250",
	"./menu/Clients.svg": "dd95",
	"./menu/ContactBook.svg": "e45d",
	"./menu/ContactInfo.svg": "3297",
	"./menu/Contacts copy.svg": "810d",
	"./menu/Contacts.svg": "a14a",
	"./menu/Contract.svg": "6797",
	"./menu/Contractor.svg": "10f0",
	"./menu/Cooperation.svg": "6436",
	"./menu/Custom Dashboard.svg": "8fd9",
	"./menu/Customer.svg": "fe83",
	"./menu/CustomerInfo.svg": "1826",
	"./menu/Dashboard copy.svg": "770e",
	"./menu/Default.svg": "186a",
	"./menu/Documentation.svg": "40b2",
	"./menu/Documents copy.svg": "942a",
	"./menu/Documents.svg": "2aff",
	"./menu/Education Icon.svg": "2631",
	"./menu/Education/Good.svg": "ffa6",
	"./menu/Education/HrmCompany.svg": "84af",
	"./menu/Education/HrmDepartment.svg": "4cac",
	"./menu/Education/LeaveManagement.svg": "e67b",
	"./menu/Education/Management.svg": "0ca3",
	"./menu/Education/Meeting.svg": "16e3",
	"./menu/Education/MultipleUser.svg": "bbdb",
	"./menu/Education/Notes.svg": "6ab7",
	"./menu/Education/Onboarding.svg": "91f1",
	"./menu/Education/OnlineEvent.svg": "4597",
	"./menu/Education/PerformanceManagement.svg": "8f4a",
	"./menu/Education/Planning.svg": "7b02",
	"./menu/Education/Productivity.svg": "03a4",
	"./menu/Education/Projects&Timesheets.svg": "eba9",
	"./menu/Education/Promotion.svg": "e8eb",
	"./menu/Education/Relationship.svg": "791a",
	"./menu/Education/SalarySlipManagement.svg": "86ac",
	"./menu/Education/Services.svg": "676c",
	"./menu/Education/SkillDevelopment.svg": "2062",
	"./menu/Education/SkillSession.svg": "f47e",
	"./menu/Education/TeamBuilding.svg": "3c5a",
	"./menu/Education/TeamManagement.svg": "7d6d",
	"./menu/Education/TeamResult.svg": "9624",
	"./menu/Education/TeamWork.svg": "a221",
	"./menu/Education/TimeManagement.svg": "fb3d8",
	"./menu/Education/VirtualBiometric.svg": "b8ae",
	"./menu/Education/WorkPolicy.svg": "0ac4",
	"./menu/Email.svg": "9c8a",
	"./menu/Employee.svg": "e4f4",
	"./menu/EmployeeCV.svg": "12b4",
	"./menu/Entities Inactive.svg": "d4b6",
	"./menu/EntitiesActive.svg": "ce29",
	"./menu/Envelope.svg": "101d",
	"./menu/Event.svg": "eb29",
	"./menu/File.svg": "06e3",
	"./menu/Flyer.svg": "e24c",
	"./menu/FolderFile.svg": "6842",
	"./menu/Form.svg": "e4f8",
	"./menu/FormTemplates.svg": "e72e",
	"./menu/Form_Inactive.svg": "c9d9",
	"./menu/Form_active.svg": "97b7",
	"./menu/Global Variable.svg": "8a16",
	"./menu/Graduated.svg": "594e",
	"./menu/Groups.svg": "6674",
	"./menu/Headhunter.svg": "578e",
	"./menu/Health.svg": "5d1e",
	"./menu/Home.svg": "2c85",
	"./menu/Hospital.svg": "e06d",
	"./menu/Hospital/Ambulance.svg": "abed",
	"./menu/Hospital/Diagnostic.svg": "7844",
	"./menu/Hospital/Doctor.svg": "6280",
	"./menu/Hospital/Eye Contrast.svg": "4917",
	"./menu/Hospital/Hospital.svg": "bf2f",
	"./menu/Hospital/Medical Examination.svg": "9779",
	"./menu/Hospital/Medical Insurance.svg": "a3da",
	"./menu/Hospital/Medical Stuff.svg": "3f78",
	"./menu/Hospital/Medical.svg": "9290",
	"./menu/Hospital/Neonatology-1.svg": "5943",
	"./menu/Hospital/Neonatology.svg": "2a1e",
	"./menu/Hospital/Online Consultation.svg": "71c8",
	"./menu/Hospital/Online Medical Report.svg": "6919",
	"./menu/Hospital/Oxygen.svg": "be95",
	"./menu/Hospital/Patient Report.svg": "1bc9",
	"./menu/Hospital/Pediatrics.svg": "f623",
	"./menu/Hospital/Radiology.svg": "e077",
	"./menu/Hospital/Sugar Checking.svg": "129e",
	"./menu/Hospital/Surgery.svg": "d1f5",
	"./menu/Hospital/Temperature.svg": "8a09",
	"./menu/Hospital/Tomography.svg": "74ab",
	"./menu/Hospital/patient.svg": "29b4",
	"./menu/Hospital/stethoscope.svg": "051d",
	"./menu/Identity.svg": "0c8d",
	"./menu/Immigration.svg": "955f",
	"./menu/Insurance.svg": "9eb1",
	"./menu/Investment.svg": "4ba5",
	"./menu/Invoice.svg": "6164",
	"./menu/JobApplication.svg": "0671",
	"./menu/JobInfo.svg": "6f4fa",
	"./menu/JobInterview-1.svg": "4553",
	"./menu/JobInterview.svg": "ce49",
	"./menu/JobOpportunities.svg": "e215",
	"./menu/JobSeeker.svg": "5de0",
	"./menu/Joboffer.svg": "5138",
	"./menu/Location.svg": "9b07",
	"./menu/Logistics/Arrival Data.svg": "142e",
	"./menu/Logistics/Cargo.svg": "f25e",
	"./menu/Logistics/Check List.svg": "1348",
	"./menu/Logistics/Communication.svg": "cc90",
	"./menu/Logistics/Directions.svg": "7cbf",
	"./menu/Logistics/Drone Shipping.svg": "b966",
	"./menu/Logistics/Fragile Things-1.svg": "f6de",
	"./menu/Logistics/Fragile Things.svg": "3f7a",
	"./menu/Logistics/Lifting Order.svg": "1e9d",
	"./menu/Logistics/Logistic.svg": "49aa",
	"./menu/Logistics/Machine.svg": "f258",
	"./menu/Logistics/Order NetWork.svg": "90ac",
	"./menu/Logistics/Order.svg": "f71b",
	"./menu/Logistics/Spirituality.svg": "0662",
	"./menu/Logistics/Storage.svg": "2296",
	"./menu/Logistics/Trucking.svg": "cb18",
	"./menu/Manufacturing/Choosing.svg": "c66f",
	"./menu/Manufacturing/Delivery.svg": "d2a3",
	"./menu/Manufacturing/Engineers.svg": "110d",
	"./menu/Manufacturing/Insoles.svg": "3a3d",
	"./menu/Manufacturing/Installation.svg": "2669",
	"./menu/Manufacturing/Laser.svg": "a5cf",
	"./menu/Manufacturing/Machines.svg": "8928",
	"./menu/Manufacturing/Marketing.svg": "1d7b",
	"./menu/Manufacturing/Packaging-1.svg": "d098",
	"./menu/Manufacturing/Packaging-2.svg": "fe8a",
	"./menu/Manufacturing/Packaging.svg": "0b81",
	"./menu/Manufacturing/Sketching.svg": "c0afb",
	"./menu/Manufacturing/Turning.svg": "04a0",
	"./menu/Manufacturing/Weightage.svg": "9e99",
	"./menu/Manufacturing/Workers.svg": "a740",
	"./menu/Marketplace.svg": "5f7b",
	"./menu/MultipleUsers.svg": "b959",
	"./menu/NewEmployee.svg": "5fab",
	"./menu/Notes.svg": "36d4",
	"./menu/Officebuilding.svg": "dda8",
	"./menu/Officechair.svg": "495c",
	"./menu/Payments.svg": "2958",
	"./menu/PayrollInfo.svg": "a6c2",
	"./menu/PersonalData.svg": "a62e",
	"./menu/PersonalDetails.svg": "2324",
	"./menu/Photo.svg": "5d88",
	"./menu/Portfolio.svg": "0228",
	"./menu/Profile.svg": "df95",
	"./menu/Property/Building.svg": "99c0",
	"./menu/Property/Check.svg": "5236",
	"./menu/Property/Construct.svg": "c360",
	"./menu/Property/Consultation.svg": "fdb4",
	"./menu/Property/Dealings.svg": "2e10",
	"./menu/Property/Document.svg": "79ea",
	"./menu/Property/Documents.svg": "55f8",
	"./menu/Property/Encashment.svg": "625d",
	"./menu/Property/Exchange.svg": "0aad",
	"./menu/Property/House Sale.svg": "00cc",
	"./menu/Property/House Searching.svg": "39db",
	"./menu/Property/House.svg": "5af3",
	"./menu/Property/Insurance.svg": "3304",
	"./menu/Property/Location House.svg": "a54a",
	"./menu/Property/Lock.svg": "cc5f",
	"./menu/Property/Mortgage.svg": "43a9",
	"./menu/Property/Owner.svg": "b8e5",
	"./menu/Property/Property Hands.svg": "f734",
	"./menu/Property/Property List.svg": "e2e5",
	"./menu/Property/Property Location.svg": "215f",
	"./menu/Property/Property Man.svg": "f6e6",
	"./menu/Property/Salesman.svg": "9c70",
	"./menu/Property/Search Property.svg": "40ef",
	"./menu/Property/Search.svg": "8ce3",
	"./menu/Property/Secure key.svg": "5d4d",
	"./menu/Property/Sold.svg": "ac87",
	"./menu/Property/Tax Payment.svg": "a299",
	"./menu/Property/Transactions.svg": "e3bd",
	"./menu/Property/View Property.svg": "eb1a",
	"./menu/Salary.svg": "cc83",
	"./menu/Skill.svg": "50f1",
	"./menu/Staffing/Chart.svg": "98ac",
	"./menu/Staffing/Check.svg": "12d8",
	"./menu/Staffing/Documents.svg": "dbdf",
	"./menu/Staffing/Educate.svg": "4e75",
	"./menu/Staffing/Employee.svg": "a41b",
	"./menu/Staffing/Network.svg": "e4ea",
	"./menu/Staffing/Raising Staff.svg": "6bd5",
	"./menu/Staffing/Scheduled Time.svg": "7787",
	"./menu/Staffing/Search Staff.svg": "0adf",
	"./menu/Staffing/Staff Call.svg": "fc84",
	"./menu/Staffing/Staff Group.svg": "5aca",
	"./menu/Staffing/Staff Management.svg": "70c3",
	"./menu/Staffing/Stuffing Level.svg": "bc51",
	"./menu/Staffing/Team Work.svg": "1900",
	"./menu/Staffing/Work.svg": "d2f7",
	"./menu/Support.svg": "dc09",
	"./menu/Templates copy.svg": "d474",
	"./menu/Templates.svg": "f2d8",
	"./menu/TermsConditions.svg": "cbb3",
	"./menu/Travel/Checking.svg": "f17c",
	"./menu/Travel/Collect Money.svg": "5c70",
	"./menu/Travel/Confirm Message.svg": "9e30",
	"./menu/Travel/Display Time Board.svg": "f68f5",
	"./menu/Travel/Genrate Ticket.svg": "ce7c",
	"./menu/Travel/Location.svg": "7739",
	"./menu/Travel/Man.svg": "91c5",
	"./menu/Travel/Metal Detector.svg": "c15d",
	"./menu/Travel/Online Ticket.svg": "e7e4",
	"./menu/Travel/Passport.svg": "d355",
	"./menu/Travel/Refund Money.svg": "53bd",
	"./menu/Travel/Ticket Checking.svg": "d928",
	"./menu/Travel/Ticket Counters.svg": "b9e4",
	"./menu/Travel/Verify.svg": "d6da",
	"./menu/Travel/Waiting Passengers.svg": "e608",
	"./menu/Trophy.svg": "0818",
	"./menu/Vendor.svg": "3ed9",
	"./menu/Verification.svg": "5bf7",
	"./menu/Visa.svg": "7afe",
	"./menu/Workflows.svg": "aa2b",
	"./menu/Working.svg": "8a89",
	"./menu/bell-icon.svg": "54bc",
	"./menu/benefits-2.svg": "5157",
	"./menu/benefits.svg": "cd1d",
	"./menu/company-document-2.svg": "3f20",
	"./menu/company-document.svg": "5d11",
	"./menu/company-onboarding.svg": "3b90",
	"./menu/company-templates-2.svg": "467fa",
	"./menu/company-templates.svg": "3f64",
	"./menu/contact_active.svg": "b7aa",
	"./menu/contracts.svg": "d08d",
	"./menu/create_document.svg": "11a7",
	"./menu/dashboard.svg": "bc91",
	"./menu/dashboard_active.svg": "329a",
	"./menu/data-variable copy.svg": "db8d",
	"./menu/data-variable.svg": "d16a8",
	"./menu/documents_active.svg": "f6d8",
	"./menu/employee-documents.svg": "7e4d",
	"./menu/employee-list.svg": "7ae17",
	"./menu/employess.svg": "fa99",
	"./menu/entities.svg": "7986",
	"./menu/file-manageer.svg": "2919",
	"./menu/menu-1.svg": "cd81",
	"./menu/menu-2.svg": "6b3d",
	"./menu/menu-3.svg": "3e924",
	"./menu/menu-4.svg": "d4a5",
	"./menu/menu-5.svg": "d6b7",
	"./menu/menu-6.svg": "2bda",
	"./menu/menu-7.svg": "22e2",
	"./menu/menu-8.svg": "b0a7",
	"./menu/menu-configuration.svg": "003e",
	"./menu/no-signature.svg": "f891",
	"./menu/notifications.svg": "b357a",
	"./menu/offer-letter.svg": "8a90",
	"./menu/onboarding.svg": "7f0b",
	"./menu/onlineresume.svg": "16df",
	"./menu/request-document.svg": "458f",
	"./menu/request-document_active.svg": "59802",
	"./menu/settings.svg": "63cb",
	"./menu/templates_active.svg": "64d3",
	"./menu/user.svg": "1c16",
	"./menu/variables.svg": "e371",
	"./menu/work-flow.svg": "c3d2",
	"./menu/workflow_active.svg": "da9f",
	"./menuApplicationUsers/Academics.svg": "80d4",
	"./menuApplicationUsers/Achievement.svg": "e0fe",
	"./menuApplicationUsers/AddressInfo.svg": "1133",
	"./menuApplicationUsers/Arrow.svg": "dc8d",
	"./menuApplicationUsers/Attendance.svg": "c5bb",
	"./menuApplicationUsers/Badge.svg": "86bc",
	"./menuApplicationUsers/BestEmployee.svg": "965a",
	"./menuApplicationUsers/Billing.svg": "9c9c",
	"./menuApplicationUsers/Calendar.svg": "2d87",
	"./menuApplicationUsers/Certificate.svg": "795b",
	"./menuApplicationUsers/Chart.svg": "7332",
	"./menuApplicationUsers/Check.svg": "beef",
	"./menuApplicationUsers/Clients.svg": "f15c",
	"./menuApplicationUsers/ContactBook.svg": "7971",
	"./menuApplicationUsers/ContactInfo.svg": "f9267",
	"./menuApplicationUsers/Contacts.svg": "74b6",
	"./menuApplicationUsers/Contract.svg": "21f6",
	"./menuApplicationUsers/Contractor.svg": "9c8ad",
	"./menuApplicationUsers/Cooperation.svg": "5523",
	"./menuApplicationUsers/Customer.svg": "c155",
	"./menuApplicationUsers/CustomerInfo.svg": "681d",
	"./menuApplicationUsers/Documentation.svg": "7de0",
	"./menuApplicationUsers/Documents.svg": "43e7",
	"./menuApplicationUsers/Download Center.svg": "429b",
	"./menuApplicationUsers/Email.svg": "2b555",
	"./menuApplicationUsers/Employee.svg": "ebb9",
	"./menuApplicationUsers/EmployeeCV.svg": "d903",
	"./menuApplicationUsers/Envelope.svg": "eb78",
	"./menuApplicationUsers/Examination.svg": "2394",
	"./menuApplicationUsers/Facebook.svg": "5424",
	"./menuApplicationUsers/Fee Collection.svg": "46f3",
	"./menuApplicationUsers/File.svg": "05e0",
	"./menuApplicationUsers/FolderFile.svg": "6d0a",
	"./menuApplicationUsers/FormTemplates.svg": "3c1d",
	"./menuApplicationUsers/Graduated.svg": "7cc9",
	"./menuApplicationUsers/Headhunter.svg": "5ffb",
	"./menuApplicationUsers/Health.svg": "8694",
	"./menuApplicationUsers/Home.svg": "08cc",
	"./menuApplicationUsers/Human Resource.svg": "4866",
	"./menuApplicationUsers/Identity.svg": "995ac",
	"./menuApplicationUsers/Immigration.svg": "8980",
	"./menuApplicationUsers/Instagram.svg": "72d3",
	"./menuApplicationUsers/Insurance.svg": "4216",
	"./menuApplicationUsers/Inventory.svg": "59eb",
	"./menuApplicationUsers/Investment.svg": "edf4",
	"./menuApplicationUsers/JobApplication.svg": "464d",
	"./menuApplicationUsers/JobInfo.svg": "a7fe",
	"./menuApplicationUsers/JobInterview-1.svg": "87e6",
	"./menuApplicationUsers/JobInterview.svg": "4a8a",
	"./menuApplicationUsers/JobOpportunities.svg": "afd5",
	"./menuApplicationUsers/JobSeeker.svg": "5d27",
	"./menuApplicationUsers/Joboffer.svg": "f0d0",
	"./menuApplicationUsers/Lead Management.svg": "cd71",
	"./menuApplicationUsers/Location.svg": "0a1c",
	"./menuApplicationUsers/MultipleUsers.svg": "d449",
	"./menuApplicationUsers/Notes.svg": "2715",
	"./menuApplicationUsers/Officebuilding.svg": "30ec",
	"./menuApplicationUsers/Officechair.svg": "d2ca",
	"./menuApplicationUsers/Payments.svg": "4e1d",
	"./menuApplicationUsers/PayrollInfo.svg": "63f0",
	"./menuApplicationUsers/PersonalData.svg": "5dd4",
	"./menuApplicationUsers/PersonalDetails.svg": "a057",
	"./menuApplicationUsers/Photo.svg": "fb5c",
	"./menuApplicationUsers/Portfolio.svg": "8e43",
	"./menuApplicationUsers/Profile.svg": "7b188",
	"./menuApplicationUsers/Salary.svg": "54b1",
	"./menuApplicationUsers/Skill.svg": "2145",
	"./menuApplicationUsers/Student Information.svg": "65b9",
	"./menuApplicationUsers/Templates.svg": "e88f",
	"./menuApplicationUsers/TermsConditions.svg": "ecd4",
	"./menuApplicationUsers/Trophy.svg": "4ca0",
	"./menuApplicationUsers/Twitter.svg": "0c5a",
	"./menuApplicationUsers/Vendor.svg": "d25a",
	"./menuApplicationUsers/Verification.svg": "3031",
	"./menuApplicationUsers/Visa.svg": "01ca",
	"./menuApplicationUsers/Workflows.svg": "49d1",
	"./menuApplicationUsers/Working.svg": "a782",
	"./menuApplicationUsers/Youtube.svg": "0c3f",
	"./menuApplicationUsers/benefits.svg": "6693",
	"./menuApplicationUsers/dashboard.svg": "5195",
	"./menuApplicationUsers/entities.svg": "0ae9",
	"./menuApplicationUsers/onboarding.svg": "6a77",
	"./menuApplicationUsers/onlineresume.svg": "01ef",
	"./menuApplicationUsersWhite/Academics.svg": "1300",
	"./menuApplicationUsersWhite/Achievement.svg": "dfc9",
	"./menuApplicationUsersWhite/AddressInfo.svg": "4b69",
	"./menuApplicationUsersWhite/Arrow.svg": "8a33",
	"./menuApplicationUsersWhite/Attendance.svg": "0b92",
	"./menuApplicationUsersWhite/Badge.svg": "f7b0",
	"./menuApplicationUsersWhite/BestEmployee.svg": "57a8",
	"./menuApplicationUsersWhite/Billing.svg": "ca4f",
	"./menuApplicationUsersWhite/Calendar.svg": "0b17",
	"./menuApplicationUsersWhite/Certificate.svg": "80b38",
	"./menuApplicationUsersWhite/Chart.svg": "518f",
	"./menuApplicationUsersWhite/Check.svg": "5fc9",
	"./menuApplicationUsersWhite/Clients.svg": "85fc",
	"./menuApplicationUsersWhite/ContactBook.svg": "4d5f",
	"./menuApplicationUsersWhite/ContactInfo.svg": "9d38",
	"./menuApplicationUsersWhite/Contacts.svg": "1d37",
	"./menuApplicationUsersWhite/Contract.svg": "f14a",
	"./menuApplicationUsersWhite/Contractor.svg": "8e78",
	"./menuApplicationUsersWhite/Cooperation.svg": "fa02",
	"./menuApplicationUsersWhite/Customer.svg": "5654",
	"./menuApplicationUsersWhite/CustomerInfo.svg": "ca15",
	"./menuApplicationUsersWhite/Documentation.svg": "b49c1",
	"./menuApplicationUsersWhite/Documents.svg": "63ac",
	"./menuApplicationUsersWhite/Download Center.svg": "8e439",
	"./menuApplicationUsersWhite/Email.svg": "d1f3",
	"./menuApplicationUsersWhite/Employee.svg": "e918",
	"./menuApplicationUsersWhite/EmployeeCV.svg": "5e58",
	"./menuApplicationUsersWhite/Envelope.svg": "ae39",
	"./menuApplicationUsersWhite/Examination.svg": "2efd4",
	"./menuApplicationUsersWhite/Fee Collection.svg": "4add",
	"./menuApplicationUsersWhite/File.svg": "c876",
	"./menuApplicationUsersWhite/FolderFile.svg": "cb31",
	"./menuApplicationUsersWhite/FormTemplates.svg": "1194",
	"./menuApplicationUsersWhite/Graduated.svg": "43fb",
	"./menuApplicationUsersWhite/Headhunter.svg": "2d6c",
	"./menuApplicationUsersWhite/Health.svg": "5681",
	"./menuApplicationUsersWhite/Home.svg": "96da",
	"./menuApplicationUsersWhite/Human Resource.svg": "a8fc",
	"./menuApplicationUsersWhite/Identity.svg": "0d00",
	"./menuApplicationUsersWhite/Immigration.svg": "b724",
	"./menuApplicationUsersWhite/Insurance.svg": "bdbd",
	"./menuApplicationUsersWhite/Inventory.svg": "a9a7",
	"./menuApplicationUsersWhite/Investment.svg": "c846",
	"./menuApplicationUsersWhite/JobApplication.svg": "1ebb",
	"./menuApplicationUsersWhite/JobInfo.svg": "d7ab",
	"./menuApplicationUsersWhite/JobInterview-1.svg": "22f5",
	"./menuApplicationUsersWhite/JobInterview.svg": "8211",
	"./menuApplicationUsersWhite/JobOpportunities.svg": "a3d8",
	"./menuApplicationUsersWhite/JobSeeker.svg": "7ddd",
	"./menuApplicationUsersWhite/Joboffer.svg": "bd35",
	"./menuApplicationUsersWhite/Lead Management.svg": "e1bf",
	"./menuApplicationUsersWhite/Location.svg": "6f34",
	"./menuApplicationUsersWhite/MultipleUsers.svg": "692f",
	"./menuApplicationUsersWhite/Notes.svg": "600c",
	"./menuApplicationUsersWhite/Officebuilding.svg": "1b1b",
	"./menuApplicationUsersWhite/Officechair.svg": "e4fb",
	"./menuApplicationUsersWhite/Payments.svg": "ace7",
	"./menuApplicationUsersWhite/PayrollInfo.svg": "f6e2",
	"./menuApplicationUsersWhite/PersonalData.svg": "463b",
	"./menuApplicationUsersWhite/PersonalDetails.svg": "5077",
	"./menuApplicationUsersWhite/Photo.svg": "bc05",
	"./menuApplicationUsersWhite/Portfolio.svg": "2bb6",
	"./menuApplicationUsersWhite/Profile.svg": "55bc",
	"./menuApplicationUsersWhite/Salary.svg": "c6ab",
	"./menuApplicationUsersWhite/Skill.svg": "b738",
	"./menuApplicationUsersWhite/Student Information.svg": "10fd",
	"./menuApplicationUsersWhite/Templates.svg": "2cce",
	"./menuApplicationUsersWhite/TermsConditions.svg": "3071",
	"./menuApplicationUsersWhite/Trophy.svg": "f145",
	"./menuApplicationUsersWhite/Vendor.svg": "cf84",
	"./menuApplicationUsersWhite/Verification.svg": "61b8",
	"./menuApplicationUsersWhite/Visa.svg": "c177",
	"./menuApplicationUsersWhite/Workflows.svg": "ce98b",
	"./menuApplicationUsersWhite/Working.svg": "2266f",
	"./menuApplicationUsersWhite/benefits.svg": "676a",
	"./menuApplicationUsersWhite/dashboard.svg": "e2da",
	"./menuApplicationUsersWhite/entities.svg": "8ccf",
	"./menuApplicationUsersWhite/onboarding.svg": "9896",
	"./menuApplicationUsersWhite/onlineresume.svg": "d448",
	"./mobile_number.svg": "7ed1",
	"./model-category.svg": "e6e7",
	"./more-icon.svg": "db3a",
	"./new-entity.svg": "34b7",
	"./no-address.svg": "21ec",
	"./no-signature.svg": "7279",
	"./not-used.svg": "19c3",
	"./offer-letter-1.svg": "daed",
	"./ol.svg": "88c5",
	"./paper.svg": "e73b",
	"./paragraph.svg": "a76b",
	"./password.svg": "7b0a",
	"./paypal.svg": "314a",
	"./pdf-file.svg": "c82a",
	"./pdf.svg": "5456",
	"./pencil.svg": "0f48",
	"./plus-icon.svg": "c3d1",
	"./png.png": "858dd",
	"./pre-defined.svg": "1e11",
	"./quote.svg": "4373",
	"./razorpay.svg": "2362",
	"./recaptcha.svg": "213b",
	"./redo.svg": "1383",
	"./remove.svg": "fa38",
	"./right-arrow.svg": "011b",
	"./round-arrow.svg": "49bf",
	"./search.svg": "0930",
	"./send-document.svg": "fb2b1",
	"./send-file.svg": "2793",
	"./send.svg": "e128",
	"./settings.svg": "cbdc",
	"./share.svg": "b551",
	"./sign-in-email.svg": "796c",
	"./signature.svg": "34f3",
	"./socialmedia-White/Facebook.svg": "775f",
	"./socialmedia-White/Instagram.svg": "648c",
	"./socialmedia-White/Twitter.svg": "1c06",
	"./socialmedia-White/Youtube.svg": "1c88",
	"./socialmedia-black/Facebook.svg": "6a37",
	"./socialmedia-black/Instagram.svg": "0ab9",
	"./socialmedia-black/Twitter.svg": "ab7b",
	"./socialmedia-black/Youtube.svg": "1e60",
	"./standard-documents.svg": "1ebe",
	"./strike.svg": "d984",
	"./stripe.svg": "2571",
	"./stripeAch.png": "20d4",
	"./support.svg": "164e",
	"./table.svg": "f538",
	"./template-2.svg": "6ee7",
	"./template.svg": "812c",
	"./templates-unused.svg": "fe5b",
	"./templates-used.svg": "15aa",
	"./templates.svg": "665b",
	"./toogle-menu.svg": "e13c",
	"./tooltip-close-icon.svg": "370c",
	"./transfer.svg": "7b18",
	"./trash-document.svg": "e819",
	"./ul.svg": "c438",
	"./underline.svg": "95a5",
	"./undo.svg": "7fa4",
	"./upload-active.svg": "058b",
	"./upload-file.svg": "6b05",
	"./upload-icon.svg": "8374",
	"./users.svg": "3a68",
	"./visibility.svg": "2d14",
	"./workflow_active.svg": "8494"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65a8";